import BedtimeIcon from "@mui/icons-material/Bedtime";
import SunnyIcon from "@mui/icons-material/WbSunny";
import { Box, PaletteMode, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { ColorContext } from "../../context/ColorContext";
import { colors } from "../../theme/colors";
import Button, { ButtonVariant } from "./Button";

const SwitchModeButtons = () => {
  const colorMode = React.useContext(ColorContext);
  const { t } = useTranslation();
  const themeLabel = t("header.theme");

  const toggleMode = (mode: PaletteMode) => {
    colorMode.toggleColorMode(mode);
  };

  return (
    <Box>
      <Typography variant="h5" mb={3}>
        {themeLabel}
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2
        }}>
        <Button
          sx={{
            width: "100%",
            "& > div, & div > p": {
              width: "100%"
            },
            color: colors.darkYellow,
            backgroundColor: "transparent",
            border: `3px solid ${colors.darkYellow}`
          }}
          variant={ButtonVariant.secondary}
          onClick={() => toggleMode("light")}
          startIcon={
            <SunnyIcon
              titleAccess={`${t("buttons.lightMode")} ${themeLabel.toLocaleLowerCase()}`}
            />
          }
          label={t("buttons.lightMode")}
          title={t("buttons.lightMode")}
        />
        <Button
          sx={{
            width: "100%",
            "& > div, & div > p": {
              width: "100%"
            },
            color: colors.black,
            backgroundColor: "transparent",
            border: `3px solid ${colors.black}`
          }}
          variant={ButtonVariant.secondary}
          onClick={() => toggleMode("dark")}
          startIcon={
            <BedtimeIcon
              titleAccess={`${t("buttons.darkMode")} ${themeLabel.toLocaleLowerCase()}`}
            />
          }
          label={t("buttons.darkMode")}
          title={t("buttons.darkMode")}
        />
      </Box>
    </Box>
  );
};

export default SwitchModeButtons;
